import * as React from "react";

import type { DesignaliProps } from "../../types";

export const AiEraser = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
        ref={forwardedRef}
      >
        <path d="M8.84,11.14l-3.77,3.85c-1.13,1.16-1.7,1.74-1.78,2.44-.02.15-.02.3,0,.45.08.71.64,1.28,1.78,2.44l.14.15c.6.62.91.93,1.27,1.13.21.12.43.22.67.28.4.11.83.11,1.69.11s1.29,0,1.69-.11c.23-.07.46-.16.67-.28.36-.21.66-.52,1.27-1.13l2.75-2.81M8.84,11.14l3.47-3.54c1.34-1.37,2.01-2.06,2.85-2.06.84,0,1.51.69,2.85,2.06l.72.74c1.32,1.35,1.99,2.03,1.99,2.87,0,.84-.66,1.52-1.99,2.87l-3.51,3.58M7.09,12.93l6.49,6.4" />
        <path d="M4.81,6.78c-.06-.25-.26-.44-.51-.51l-2.17-.56c-.09-.03-.15-.12-.12-.22.02-.06.06-.11.12-.12l2.17-.56c.25-.06.44-.26.51-.51l.56-2.17c.03-.09.12-.15.22-.12.06.02.11.06.12.12l.56,2.17c.06.25.26.44.51.51l2.17.56c.09.03.15.12.12.22-.02.06-.06.11-.12.12l-2.17.56c-.25.06-.44.26-.51.51l-.56,2.17c-.03.09-.12.15-.22.12-.06-.02-.11-.06-.12-.12l-.56-2.17Z" />
      </svg>
    );
  },
);

export default AiEraser;
